import { API_BASE_URL } from "../config";

export async function apiFetch(url, options = {}) {
  try {
    const res = await fetch(`${API_BASE_URL}${url}`, {
      ...options,
      credentials: "include",
      headers: {
        "Content-Type": options.headers?.["Content-Type"] || "application/json",
        ...options.headers,
      },
    });

    // Redirige al login si 401
    if (res.status === 401) {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      return null; // indica sin acceso
    }

    return res;
  } catch (err) {
    console.error("Fetch error:", err);
    return null;
  }
}
